/// <amd-module name="Release/Progress/Helpers/ReleaseProgressBreadCrumbService" />
import { IReadonlyObservableArray, ObservableArray } from "VSS/Core/Observable";
import { Services, VssService } from "VSS/Platform/Context";
import { onClickFPS } from "VSS/Platform/FPS";
import { IBreadcrumbItemService } from "VSS/Features/PlatformUI/ContributedBreadcrumb";
import { IBreadcrumbItem } from "VSSUI/Breadcrumb.Types";
import * as Resources from "Release/Progress/Helpers/Resources"

export class ReleaseProgressBreadCrumbService extends VssService implements IBreadcrumbItemService {

    private items = new ObservableArray<IBreadcrumbItem>();

    public getBreadcrumbItems(breadcrumbId: string): IReadonlyObservableArray<IBreadcrumbItem> {
        return this.items;
    }

    public setBreadcrumbs(releaseLandingPageUrl: string, releaseDefinitionName?: string, releaseDefinitionUrl?: string, releaseName?: string, releaseUrl?: string) {
        this.items.removeAll();

        this.items.push({
            key: "release-landing-breadcrumb",
            text: Resources.ReleasesLandingBreadcrumbText,
            href: releaseLandingPageUrl,
            onClick: (ev) => {
                onClickFPS(this.pageContext, releaseLandingPageUrl, true, ev, { telemetrySource: "release-landing-breadcrumb" });
            }
        });

        if (releaseDefinitionName != undefined && releaseDefinitionUrl != undefined){
            this.items.push({
                key: "release-definition-breadcrumb",
                text: releaseDefinitionName,
                href: releaseDefinitionUrl,
                onClick: (ev) => {
                    onClickFPS(this.pageContext, releaseDefinitionUrl, true, ev, { telemetrySource: "release-definition-breadcrumb" });
                }
            });
        }

        if (releaseName != undefined && releaseUrl != undefined){
            this.items.push({
                key: "release-breadcrumb",
                text: releaseName,
                href: releaseUrl,
                onClick: (ev) => {
                    onClickFPS(this.pageContext, releaseUrl, true, ev, { telemetrySource: "release-breadcrumb" });
                }
            });
        }
    }

    public clearBreadcrumbs() {
        this.items.removeAll();
    }
}

Services.add("release-progress-breadcrumb-service", { serviceFactory: ReleaseProgressBreadCrumbService });
